module.exports = __webpack_public_path__ + "img/按钮保存蓝色.234ef813.png";